// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Campaign40FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Campaign40Filled: FC<Campaign40FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="M30.278 21.389V18.61h6.389v2.778h-6.39Zm2.055 11.944L27.195 29.5l1.666-2.222L34 31.11l-1.667 2.222Zm-3.388-20.639-1.667-2.222 5.055-3.805L34 8.889l-5.055 3.805ZM8.61 31.667V25h-2.5c-.768 0-1.423-.27-1.965-.813a2.677 2.677 0 0 1-.813-1.965v-4.444c0-.769.271-1.424.813-1.965A2.677 2.677 0 0 1 6.11 15h7.222l8.334-5v20l-8.334-5H11.39v6.667H8.61Zm14.722-6.084V14.417a7.612 7.612 0 0 1 1.813 2.437c.458.959.687 2.007.687 3.146 0 1.139-.229 2.188-.687 3.146a7.612 7.612 0 0 1-1.813 2.437Z" />
        </svg>
    );
};

export default Campaign40Filled;
